<template>
  <div class="physioDrugEdit">
    <el-dialog
      title="编辑商品信息"
      :visible.sync="visible"
      width="960px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content" v-loading="loading">
        <el-form ref="form" class="form" :model="form" :rules="rules" label-width="100px">
          <div class="section">
            <div class="section_header">
              <div class="section_header_title">项目基本信息</div>
            </div>
            <div class="section_info">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="货号：">
                    <span class="section_text">{{ form.artNo }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="商品名称：">
                    <span class="section_text">{{ form.physioKindName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位：">
                    <span class="section_text">{{ form.unit }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="section">
            <div class="section_header">
              <div class="section_header_title">项目操作信息</div>
            </div>
            <div class="section_info">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="所属大类：" prop="firstCategory.categoryId">
                    <el-select v-model="form.firstCategory.categoryId" placeholder="请选择" @change="firstCategoryChange">
                      <el-option
                        v-for="item in firstCategoryList"
                        :key="item.id"
                        :label="item.physioLabel"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所属小类：" prop="secondCategory.categoryId">
                    <el-select v-model="form.secondCategory.categoryId" placeholder="请选择">
                      <el-option
                        v-for="item in secondCategoryList"
                        :key="item.id"
                        :label="item.physioLabel"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="服务时长：" prop="serviceTime">
                    <div class="form_time">
                      <el-input v-model.trim="form.serviceTime" placeholder="项目服务时长" @input="val => form.serviceTime = val.replace(/\D/g, '')"></el-input>
                      <span class="form_time_unit">分钟</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="标准时长：" prop="executeTime">
                    <div class="form_time">
                      <el-input v-model.trim="form.executeTime" placeholder="医生标准操作时长" @input="val => form.executeTime = val.replace(/\D/g, '')"></el-input>
                      <span class="form_time_unit">分钟</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="special">
                <div class="special_label">
                  <el-form-item class="special_label_item" label="特定时长：">
                    <div class="special_add" @click="addSpecial">
                      <span class="el-icon-plus special_add_icon"></span>
                      <span class="special_add_text">添加医师</span>
                    </div>
                  </el-form-item>
                </div>
                <div class="special_tips">当医生操作时长与平台标准不一致时，可在此为特定医师单独设定操作时长</div>
                <div v-if="form.specialConfigs.length > 0" class="special_list">
                  <div v-for="(special, specialIndex) in form.specialConfigs" :key="special.vId" class="special_item">
                    <div class="special_item_left">
                      <el-form-item class="special_item_form_item" label-width="0px" :show-message="false" :prop="`specialConfigs[${specialIndex}].doctorId`" :rules="{ required: true }">
                        <el-select v-model="special.doctorId" placeholder="选择医师" filterable @change="specialDoctorChange(special)">
                          <el-option v-for="doctor in doctorOptions" :label="doctor.doctorName" :value="doctor.doctorId"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item class="special_item_form_item" label-width="0px" :show-message="false" :prop="`specialConfigs[${specialIndex}].executeTime`" :rules="{ pattern: /^[1-9]\d*$/, required: true, trigger: 'blur' }">
                        <el-input v-model.trim="special.executeTime" placeholder="操作时长" @input="val => special.executeTime = val.replace(/\D/g, '')"></el-input>
                      </el-form-item>
                      <span class="special_item_form_unit">分钟</span>
                    </div>
                    <div class="special_item_right">
                      <div class="pecial_item_btn" @click="delSpecial(special.vId)">删除</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getPhysioCategoryList, getPhysioConfigByArtNo, postPhysioConfig } from '@/api/physio.js'

  export default {
    name: 'physioDrugEdit',
    data () {
      return {
        visible: false,
        loading: false,
        firstCategoryList: [],
        secondCategoryList: [],
        doctorOptions: [],
        rules: {
          'firstCategory.categoryId': [{ required: true, message: '请选择大类', trigger: 'change' }],
          'secondCategory.categoryId': [{ required: true, message: '请选择小类', trigger: 'change' }],
          'serviceTime': [
            { required: true, message: '请输入项目服务时长', trigger: 'blur' },
            { pattern: /^[1-9]\d*$/, message: '请输入有效的正整数', trigger: 'blur' }
          ],
          'executeTime': [
            { required: true, message: '请输入医生标准操作时长', trigger: 'blur' },
            { pattern: /^[1-9]\d*$/, message: '请输入有效的正整数', trigger: 'blur' }
          ]
        },
        form: {
          spu: '',
          artNo: '',
          physioKindName: '',
          unit: '',
          firstCategory: {
            categoryId: ''
          },
          secondCategory: {
            categoryId: ''
          },
          serviceTime: '',
          executeTime: '',
          specialConfigs: []
        }
      }
    },
    methods: {
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      async getFirstCategory () {
        const res = await getPhysioCategoryList()
        if (res.code === 200) {
          this.firstCategoryList = res.data.filter(v => v.level === 1)
        }
      },
      async getSecondCategory () {
        if (['', null, undefined].includes(this.form.firstCategory.categoryId)) {
          this.secondCategoryList = []
        } else {
          const res = await getPhysioCategoryList({ categoryId: this.form.firstCategory.categoryId })
          if (res.code === 200) {
            this.secondCategoryList = res.data || []
          }
        }
      },
      async getDetail () {
        this.loading = true
        const res = await getPhysioConfigByArtNo({ spu: this.form.spu })
        this.loading = false
        if (res.code === 200) { 
          this.form.artNo = res.data.artNo || ''
          this.form.physioKindName = res.data.physioKindName || ''
          this.form.unit = res.data.unit || ''
          
          this.form.firstCategory.categoryId = res.data.firstCategory && res.data.firstCategory.categoryId || ''
          if (res.data.firstCategory && res.data.firstCategory.categoryId) {
            this.firstCategoryList = [{ id: res.data.firstCategory.categoryId, physioLabel: res.data.firstCategory.physioLabel }]
          }
          this.form.secondCategory.categoryId = res.data.secondCategory && res.data.secondCategory.categoryId || ''
          if (res.data.secondCategory && res.data.secondCategory.categoryId) {
            this.secondCategoryList = [{ id: res.data.secondCategory.categoryId, physioLabel: res.data.secondCategory.physioLabel }]
          }

          this.form.serviceTime = ['', null, undefined].includes(res.data.serviceTime) ? '' : res.data.serviceTime
          this.form.executeTime = ['', null, undefined].includes(res.data.executeTime) ? '' : res.data.executeTime
          this.form.specialConfigs = res.data.specialConfigs && res.data.specialConfigs.map(v => {
            return { ...v, vId: this.generateUUID() }
          }) || []
          this.getFirstCategory()
          this.getSecondCategory()
        }
      },

      async open (spu) {
        this.visible = true
        this.form.spu = spu
        this.$getDoctorOptions()
        this.getDetail()
      },
      close () {
        this.visible = false
        this.form.spu = ''
        this.form.artNo = ''
        this.form.physioKindName = ''
        this.form.unit = ''
        this.form.firstCategory.categoryId = ''
        this.form.secondCategory.categoryId = ''
        this.form.serviceTime = ''
        this.form.executeTime = ''
        this.form.specialConfigs = []
      },
      firstCategoryChange () {
        this.form.secondCategory.categoryId = ''
        this.getSecondCategory()
      },
      addSpecial () {
        this.form.specialConfigs.unshift({
          vId: this.generateUUID(),
          spu: '',
          doctorId: '',
          executeTime: ''
        })
      },
      specialDoctorChange (special) {
        const hasExist = this.form.specialConfigs.some(v => (v.vId !== special.vId) && (v.doctorId === special.doctorId))
        if (hasExist) {
          this.$message.error('请勿重复添加医生')
          special.doctorId = ''
        }
      },
      delSpecial (vId) {
        const index = this.form.specialConfigs.findIndex(v => v.vId === vId)
        if (index > -1) {
          this.form.specialConfigs.splice(index, 1)
        }
      },
      submit () {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            this.loading = true
            const res = await postPhysioConfig(this.form)
            this.loading = false
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.close()
              this.$parent.getList()
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .physioDrugEdit /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .physioDrugEdit /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .physioDrugEdit /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .physioDrugEdit /deep/ .el-dialog__body {
    padding: 0;
  }

  .physioDrugEdit /deep/ .el-dialog__footer {
    padding: 12px 16px;
  }

  .content {
    padding: 20px;
    max-height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .form {
    overflow: hidden;
  }

  .form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #333333;
  }

  .form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .section {
    width: 100%;
  }

  .section_header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .section_header_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
  }

  .section_header_title::before {
    content: '';
    display: block;
    margin: 0 8px 0 0;
    width: 3px;
    height: 16px;
    background-color: #1890FF;
    border-radius: 2px;
  }

  .section_info {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .form_time {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .form_time_unit {
    flex-shrink: 0;
    margin: 0 0 0 8px;
    font-size: 14px;
    color: #333333;
  }

  .special_label_item {
    margin-bottom: 0px;
  }

  .special_add {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    width: fit-content;
    height: 32px;
    background-color: #FFFFFF;
    border: 1px solid #1890FF;
    border-radius: 2px;
    cursor: pointer;
  }

  .special_add_icon {
    font-size: 14px;
    color: #1890FF;
  }

  .special_add_text {
    margin: 0 0 0 4px;
    font-size: 14px;
    color: #1890FF;
  }

  .special_tips {
    margin: 4px 0 0 0;
    line-height: 22px;
    font-size: 12px;
    color: #999999;
  }

  .special_list {
    box-sizing: border-box;
    margin: 8px 0 0 0;
    padding: 12px 16px;
    width: 610px;
    background-color: #F5F7FA;
  }

  .special_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .special_item+.special_item {
    margin: 16px 0 0 0;
  }

  .special_item_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .special_item_form_item {
    margin-bottom: 0px;
    width: 140px;
  }

  .special_item_form_item+.special_item_form_item {
    margin-left: 12px;
  }

  .special_item_form_unit {
    margin: 0 0 0 8px;
    font-size: 14px;
    color: #333333;
  }

  .special_item_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .pecial_item_btn {
    line-height: 22px;
    font-size: 14px;
    color: #808080;
    cursor: pointer;
  }

</style>